module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 481
// module chunks = 0